// extracted by mini-css-extract-plugin
export var columnList = "_ek-0";